import React, { useState, useEffect } from "react";
import classes from "./Sidebar.module.css";
import logo from "../../Assest/logo.png";
import { NavLink } from "react-router-dom";
import {
  FiGrid,
  FiUsers,
  FiCalendar,
  FiUser,
  FiHeart,
  FiPackage,
  FiActivity,
  FiImage,
  FiHome,
  FiScissors,
  FiCreditCard,
  FiShield,
  FiFileText,
  FiArchive,
  FiBarChart2,
  FiSettings,
  FiSun,
  FiMoon,
  FiMenu,
  FiX,
  FiGitBranch, // <--- Imported GitBranch for Department
} from "react-icons/fi";

const Sidebar = () => {
  const [showSidebar, setShowSidebar] = useState(false);
  const [isLightMode, setIsLightMode] = useState(false);

  // Load theme preference from localStorage
  useEffect(() => {
    const savedTheme = localStorage.getItem("sidebarTheme");
    if (savedTheme === "light") {
      setIsLightMode(true);
    }
  }, []);

  const toggleTheme = () => {
    setIsLightMode(!isLightMode);
    localStorage.setItem("sidebarTheme", !isLightMode ? "light" : "dark");
  };

  const menus = [
    { title: "Dashboard", icon: <FiGrid />, path: "/dashboard" },
    { title: "Patients", icon: <FiUsers />, path: "/patient" },
    { title: "Appointments", icon: <FiCalendar />, path: "/appointments" },
    { title: "Doctors", icon: <FiUser />, path: "/doctors" },
    { title: "Nurses", icon: <FiHeart />, path: "/nurses" },
    { title: "Department", icon: <FiGitBranch />, path: "/department" },
    { title: "Pharmacy", icon: <FiPackage />, path: "/pharmacy" },
    { title: "Laboratory", icon: <FiActivity />, path: "/laboratory" },
    { title: "Radiology", icon: <FiImage />, path: "/radiology" },
    { title: "Wards & Beds", icon: <FiHome />, path: "/wards" },
    { title: "Theatre", icon: <FiScissors />, path: "/theatre" },
    { title: "Billing & Payments", icon: <FiCreditCard />, path: "/Billings" },
    { title: "Insurance / HMO", icon: <FiShield />, path: "/insurance" },
    { title: "Medical Records(EMR)", icon: <FiFileText />, path: "/medical-records" },
    { title: "Inventory", icon: <FiArchive />, path: "/inventory" },
    { title: "Reports", icon: <FiBarChart2 />, path: "/reports" },
    { title: "Staff Management", icon: <FiUsers />, path: "/staff-management" },
    { title: "Settings", icon: <FiSettings />, path: "/settings" },
  ];

  return (
    <>
      <button
        className={classes.hamburger}
        onClick={() => setShowSidebar(true)}
      >
        <FiMenu />
      </button>

      {showSidebar && (
        <div
          className={classes.overlay}
          onClick={() => setShowSidebar(false)}
        />
      )}

      <aside
        className={`${classes.sidebar} ${isLightMode ? classes.lightMode : classes.darkMode} ${showSidebar ? classes.showSidebar : ""}`}
      >
        <div className={classes.mobileHeader}>
          <button
            className={classes.closeBtn}
            onClick={() => setShowSidebar(false)}
          >
            <FiX />
          </button>
        </div>

        <div className={classes.logoArea}>
          <img
            src={logo}
            alt="logo"
            className={`${classes.logo} ${isLightMode ? classes.logoLight : classes.logoDark}`}
          />
          <div>
            <h3 className={isLightMode ? classes.lightText : classes.darkText}>
              City Care
            </h3>
            <span className={isLightMode ? classes.lightSubText : classes.darkSubText}>
              Hospital
            </span>
          </div>
        </div>

        <div className={classes.menu}>
          {menus.map((item, index) => (
            <NavLink
              key={index}
              to={item.path}
              className={({ isActive }) =>
                `${classes.item} ${isActive ? classes.active : ""}`
              }
              onClick={() => setShowSidebar(false)}
            >
              <span className={classes.icon}>{item.icon}</span>
              <p>{item.title}</p>
            </NavLink>
          ))}
        </div>

        <div className={classes.bottom}>
          <div className={classes.mode} onClick={toggleTheme}>
            <div className={classes.leftMode}>
              {isLightMode ? <FiMoon /> : <FiSun />}
              <span>{isLightMode ? "Dark Mode" : "Light Mode"}</span>
            </div>
            <div className={`${classes.switch} ${isLightMode ? classes.switchActive : ""}`}>
              <div className={`${classes.circle} ${isLightMode ? classes.circleActive : ""}`}></div>
            </div>
          </div>
          <p className={isLightMode ? classes.lightFooter : classes.darkFooter}>
            © 2024 City Care Hospital
            <br />
            All rights reserved.
          </p>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;